// extracted by mini-css-extract-plugin
export default {"wrapper":"Gantt_wrapper__N5G1+"};